/**
 * Function that logout user from the member portal.
 */
import { Services } from '@/services/Services';
import { clearSessionObject } from './SessionStorageUtils';

export default function logoutMember(logoutURL, isAutoLogout = false) {
  clearSessionObject();
  const buildReturnUrl = () => {
    return encodeURI(`${window.location.origin}/?auto-logged-out=true`);
  };

  const logoutUrl = `${Services.COMMON.BASE_API_URL}${logoutURL}${isAutoLogout === true ? `?returnUrl=${buildReturnUrl()}` : ''}`;
  window.location.assign(logoutUrl);
}
